/**
 * Pre-compiled fr-FR messages for NumberInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { decrement: `Décrément`, increment: `Incrément` };
